import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import FormCheckbox from '../FormCheckbox/FormCheckbox.vue'
import FormInputDropdown from '../FormInputDropdown/FormInputDropdown.vue'
import StafetPayment from '../StafetPayment/StafetPayment.vue'
import StafetActions from '../StafetActions/StafetActions.vue'
import { ref, computed, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import fieldValidator from 'foundation/js/stafet/fieldValidator'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import fieldsConfig from './config/fieldsConfig'
import getFieldValue from 'foundation/js/stafet/getFieldValue'

export default {
    name: 'StafetDeltagSomFighterStepThree',
    components: {
        FormCheckbox,
        FormInputDropdown,
        StafetPayment,
        StafetActions
    },
    props: _stafetCommonStepsProps,
    setup(props) {
        const store = useStore()
        const joinATeam = ref(false)
        const isChild = ref(false)
        const teamName = ref('')        
        const newsletter = ref(false)

        const basket = computed(() => {
            return store.state.stafet.basket
        })

        const basketTotalPrice = computed(() => {
            return store.state.stafet.basketTotalPrice
        })

        const teams = computed(() => {
            const array = []
            if (props.holdList) {
                props.holdList.forEach((hold) =>
                    array.push({ name: hold.name, value: hold.holdKode })
                )
            }

            return array
        })

        onBeforeMount(() => {
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_JOIN_AS_FIGHTER
            )

            if (storedFields) {
                updateLocalRefs([
                    {
                        name: 'joinATeam',
                        value: getFieldValue(storedFields, 'joinATeam')
                    },
                    {
                        name: 'isChild',
                        value: getFieldValue(storedFields, 'isChild')
                    },
                    {
                        name: 'teamName',
                        value: getFieldValue(storedFields, 'teamName')
                    },
                    {
                        name: 'newsletter',
                        value:
                            getFieldValue(storedFields, 'newsletter') ??
                            newsletter.value
                    }
                ])
            }

            store.dispatch('donation/teams', { stafetId: props.stafetId })
        })

        const updateLocalRefs = (fields) => {
            fields.forEach((field) => {
                if (field.value === undefined || field.value === null) return
                fieldsConfig.find((item) => item.name === field.name).value =
                    field.value
                switch (field.name) {
                    case 'joinATeam':
                        joinATeam.value = field.value
                        return
                    case 'isChild':
                        isChild.value = field.value
                        return
                    case 'teamName':
                        teamName.value = field.value
                        return
                    case 'newsletter':
                        newsletter.value = field.value
                        return
                    default:
                        return
                }
            })
        }

        const validateField = (fieldName, value) => {
            updateLocalRefs([{ name: fieldName, value: value }]) // update local refs and keep in sync with fieldsConfig
            const field = fieldsConfig.find((field) => field.name === fieldName)
            if (field) {
                field.value = value
                fieldValidator(field)
            }
        }

        const setJoinATeam = (value) => {
            joinATeam.value = value
            store.dispatch('stafet/userInputs', {
                inputs: [
                    { name: 'joinATeam', isValid: true, value: joinATeam.value }
                ]
            })
            validateField('joinATeam', value)
            if (props.updateBasketCallback) {
                props.updateBasketCallback()
            }
        }

        const setIsChild = (value) => {
            isChild.value = value
            store.dispatch('stafet/userInputs', {
                inputs: [
                    { name: 'isChild', isValid: true, value: isChild.value }
                ]
            })
            if (props.updateBasketCallback) {
                props.updateBasketCallback()
            }
            validateField('isChild', value)
        }

        const stepModel = computed(() => {
            return fieldsConfig
        })

        const handleErrorMessage = (fieldName) => {
            const field = fieldsConfig.find((field) => field.name === fieldName)
            return !field?.isValid && props.displayInputError
        }

        return {
            joinATeam,
            isChild,
            teamName,
            teams,
            basket,
            basketTotalPrice,
            stepModel,
            setJoinATeam,
            newsletter,
            setIsChild,
            validateField,
            handleErrorMessage
        }
    }
}
